import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import React, { useEffect, useMemo, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import api from '@/shared/api';
import config from '@/config';
import handleHttpError from '@/shared/services/HandleHttpError';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import AuthService, { privileges } from '@/shared/services/AuthService';
import MultiSelect, { addItem, removeItem, splitItems } from './MultiSelect';
const messages = defineMessages({
    EnterTag: {
        id: 'EnterTag',
        defaultMessage: 'Enter tag',
    },
});
export const TaskTagsMultiSelect = ({ selection, onChange, placeholder, allowNew = false, small = false, disabled = false, }) => {
    const intl = useIntl();
    const [items, setItems] = useState([]);
    useEffect(() => {
        let mounted = true;
        api.base.get(`${config.appUrls.tasks}/api/Tags`).then(({ data }) => {
            if (!mounted)
                return;
            setItems(data.map(({ id, name }) => ({ id, label: name })).sort(dynamicSort('label')));
        }, error => {
            handleHttpError(intl)(error);
        });
        return () => {
            mounted = false;
        };
    }, [intl]);
    const canCreateTags = useMemo(() => AuthService.hasPermission({
        functionality: 'Tags',
        privilege: privileges.Create,
    }), []);
    const findOrCreateTag = tagName => new Promise((resolve, reject) => {
        const tag = items.find(t => t.label.toLowerCase() === tagName.toLowerCase());
        if (tag) {
            resolve(tag);
        }
        else {
            api.base.post(`${config.appUrls.tasks}/api/Tags`, { name: tagName }).then(({ data }) => {
                if (!data)
                    return reject();
                const newTag = { id: data.id, label: data.name };
                setItems(oldItems => [...oldItems, newTag].sort(dynamicSort('label')));
                resolve(newTag);
            }, reject);
        }
    });
    const onCreateItem = async (inputValue) => {
        if (!inputValue || !allowNew || !canCreateTags)
            return;
        const item = await findOrCreateTag(inputValue);
        if (!item)
            return;
        onChange(addItem(selection, item));
    };
    const [selectedItems, selectableItems] = splitItems(items, selection);
    return (_jsx(MultiSelect, { selectedItem: selectedItems, onItemRemoved: item => onChange(removeItem(selection, item)), onItemSelected: item => onChange(addItem(selection, item)), onCreateItem: allowNew && canCreateTags ? onCreateItem : undefined, items: selectableItems, placeholder: placeholder || intl.formatMessage(messages.EnterTag), isSmall: small, disabled: disabled }));
};
